import { api } from '..';
import { Preset } from '../../ui/filter-panel/types';

export const getPresets = async (): Promise<Preset[]> => {
  try {
    const data = await api.get('/api/v1/general/user/preset/');
    return data as Preset[];
  } catch {
    return [];
  }
};
